/* eslint-disable react/no-danger */
/* eslint-disable max-len */
import React from 'react';
import {
  Container,
  Divider,
  Grid,
  Typography,
} from '@material-ui/core';

import Layout from '../../components/layout';

const rows = [
  { title: '販売業者', body: '合同会社ふたさじ (Futasaji LLC)' },
  { title: '代表者', body: '代表社員 佐藤 弘幸' },
  { title: '本社所在地', body: '〒105-0013<br/>東京都港区浜松町2丁目2番15号 浜松町ダイヤビル2F' },
  { title: 'お問い合わせ', body: 'support@futasaji.netへお問い合わせください。<br/>※弊社電話番号はお客様からのご要望に基づき遅滞なく電子メールにて通知いたします。弊社電話番号が必要なお客様は電子メールにてお申し出ください。' },
  { title: '販売価格', body: 'iTunes App Store、Google Playの決済ページに表示しております。' },
  { title: '販売価格以外の費用', body: 'インターネット接続料金、通信料金等はお客様の負担となります。' },
  { title: '支払方法', body: ' iTunes App Store、Google Playが定める方法' },
  { title: 'サービス提供時期', body: ' 特別な定めを置いている場合を除き、お支払い手続き完了後直ちにご利用いただけます。' },
  { title: '返品等の対応', body: ' サービスの特性上、返品、交換はできず、現状有姿での提供となります。' },
  { title: '動作環境', body: ' 対象のアプリが動作するiOS（iPhone）端末、またはAndroid端末が必要です。' },
];

const Page = () => (
  <Layout>
    <Container maxWidth="md">
      <Typography align="center" paragraph variant="h5" style={{ marginBottom: 64 }}>特定商取引法に基づく表記</Typography>
      {rows.map((value) => (
        <div>
          <Grid container spacing={1} style={{ marginTop: 20, marginBottom: 20 }}>
            <Grid item xs={4}><Typography variant="body2">{ value.title }</Typography></Grid>
            <Grid item xs={8}>
              <Typography variant="body2">
                <div dangerouslySetInnerHTML={{ __html: value.body }} />
              </Typography>
            </Grid>
          </Grid>
          <Divider />
        </div>
      ))}

    </Container>
  </Layout>
);

export default Page;
